import {createStyles, SegmentedControl, Stack, Text} from '@mantine/core';
import React from 'react';

import {FONT_PROXIMA_TITLE, FONT_PROXIMA_12} from 'styles/FontConstants';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import {CreationMode} from './DefineScratchPlateSettingsStep';

export interface PlateCreationMethodToggleProps {
  creationMode: CreationMode;
  onChange: (mode: CreationMode) => void;
}

export default function PlateCreationMethodToggle({
  creationMode,
  onChange,
}: PlateCreationMethodToggleProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Stack spacing="xs">
      <FieldLabel label="Creation method" labelStyle={FieldLabel.STYLES.LABEL} />
      <SegmentedControl
        aria-label="Creation method"
        classNames={{label: classes.segmentLabel, control: classes.segmentControl}}
        data={[
          {
            label: (
              <Text className={classes.segmentLabelText}>
                <Text className={classes.segmentLabelTitle}>Create from scratch</Text>
                Manually define the name, size, well roles, and concentration layers of your plate design.
              </Text>
            ),
            value: CreationMode.SCRATCH,
          },
          {
            label: (
              <Text className={classes.segmentLabelText}>
                <Text className={classes.segmentLabelTitle}>Create from template</Text>
                Use an existing template to define your plate design. Updates can be made before the design is
                created.
              </Text>
            ),
            value: CreationMode.TEMPLATE,
          },
        ]}
        value={creationMode}
        onChange={(value) => {
          onChange(value as CreationMode);
        }}
      />
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  segmentLabelText: {
    display: 'inline',
    ...FONT_PROXIMA_12,
  },
  segmentLabelTitle: {
    ...FONT_PROXIMA_TITLE,
  },
  segmentLabel: {
    whiteSpace: 'normal',
    height: '100%',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  segmentControl: {
    height: 'auto',
    alignSelf: 'stretch',
  },
}));
